export default __webpack_public_path__ + "static/media/star.500292be.svg";